export default "__VITE_ASSET__BvtB_bDi__"